export default __webpack_public_path__ + "static/media/element_61.030ac365.jpg";